import React, { useState, useEffect, useRef } from 'react';
import { Timer } from '../../Components/Games/SpellBee/GameComponents/CountdownTimer';
import AppButton from '../../Components/Common/AppButton';
import { InGameNotificationPopup } from '../../Components/Games/SpellBee/InGameNotificationPopup';
import { AnimatePresence, motion } from "framer-motion";
import BottomButtonBar from '../../Components/Common/BottomButtonBar';
import { Dialog } from '@mui/material';
import { attempt, set } from 'lodash';
import { NEW_FORMAT_TOURNAMENT_GAME_TIMER, NEW_FORMAT_TOURNAMENT_GAME_TRIAL_TIMER } from '../../Constants/Commons';

const ShoppingCartRound = ({ gameState, updateGameState, submitGame, isTrialGame, currentActiveIndex, totalQuestions, currentActiveQuestion, roundsPerQuestion }) => {
    const roundTimerDuration = isTrialGame ? NEW_FORMAT_TOURNAMENT_GAME_TRIAL_TIMER["SHOPPING_CART"] : NEW_FORMAT_TOURNAMENT_GAME_TIMER["SHOPPING_CART"];
    const [currentActiveIndexInternal, setCurrentActiveIndexInternal] = useState(0);

    const [pauseTimer, setPauseTimer] = useState(true);
    const [showShoppingList, setShowShoppingList] = useState(true);
    const [tutorialStep, setTutorialStep] = useState(0);
    const [shoppingList, setShoppingList] = useState(currentActiveQuestion.shoppingList);
    const [shooppingListBreif, setShoppingListBreif] = useState([]);
    const [showCart, setShowCart] = useState(false);
    const [showInGameNotificationPopup, setShowInGameNotificationPopup] = useState(false);
    const [showWaitScreen, setShowWaitScreen] = useState(false);
    const [submittedShoppingList, setSubmittedShoppingList] = useState([]);
    const scoreRef = React.useRef(0);
    const timerRef = useRef(null);

    useEffect(() => {
        const updatedShoppingList = currentActiveQuestion.shoppingList.map(item => ({
            item: item.item,
            quantity: item.quantity,
        }));
        setShoppingListBreif(updatedShoppingList);
        const tempList = currentActiveQuestion.shoppingList.map(item => ({
            //map through the shopping list and set the options to 0
            ...item,
            options: item.options.map(option => ({
                ...option,
                selected: 0,
            })),
        }));
        setShoppingList(tempList);
        setCurrentActiveIndexInternal(0)
        setShowShoppingList(true)
        setShowWaitScreen(false);
    }, [currentActiveQuestion]);


    const returnDiscountCode = (option) => {
        switch (option.discountMode) {
            case "percentage":
                return `${option.discount}%`;
            case "mrpDiscount":
                return `₹${option.discount}`;
            case "x+y":
                return `${option.discount.buy} + ${option.discount.free} FREE`;
            default:
                return ""
        }
        return "";
    };

    const currentItem = shoppingList[currentActiveIndexInternal];

    const updateSelected = (optionIndex, increment) => {
        setShoppingList(prevList => {
            const updatedList = [...prevList];
            const currentItemCopy = { ...updatedList[currentActiveIndexInternal] };
            const updatedOptions = [...currentItemCopy.options];

            const currentOption = updatedOptions[optionIndex];

            let newSelectedForOption = Math.max(currentOption.selected + increment, 0);


            let addedFreeItems = false;

            if (currentOption.discountMode === "x+y" && increment > 0) {
                const buyCount = currentOption.discount.buy;
                const freeCount = currentOption.discount.free;
                const remainder = newSelectedForOption % (buyCount + freeCount);
                const isDivisible = remainder % (buyCount) === 0;
                if (isDivisible) {
                    newSelectedForOption += freeCount;
                }
                addedFreeItems = newSelectedForOption % (buyCount + freeCount) === 0 && newSelectedForOption > 0;
            }
            else if (currentOption.discountMode === "x+y" && increment < 0) {
                if ((newSelectedForOption + 1) % (currentOption.discount.buy + currentOption.discount.free) === 0) {
                    newSelectedForOption -= currentOption.discount.free;
                }

                addedFreeItems = newSelectedForOption % (currentOption.discount.buy + currentOption.discount.free) === 0 && newSelectedForOption > 0;

            }


            updatedOptions[optionIndex] = {
                ...currentOption,
                selected: newSelectedForOption,
                addedFreeItems: addedFreeItems,
            };

            const isCorrectSelection = matchOptions(updatedOptions, currentItemCopy.correctOptions);

            if (isTrialGame) {
                if (isCorrectSelection && tutorialStep === 0) {
                    setTutorialStep(tutorialStep + 1);
                }
            }
            currentItemCopy.options = updatedOptions;
            updatedList[currentActiveIndexInternal] = currentItemCopy;
            return updatedList;
        });
    };

    function matchOptions(updatedOptions, correctOptions) {
        // 1. Pull out only the options the user actually selected (>0)
        const selections = updatedOptions.filter(o => o.selected > 0);

        // 2. Every correct entry must be found in selections
        const allCorrectFound = correctOptions.every(({ option, quantity }) =>
            selections.some(o => o.option === option && o.selected === quantity)
        );

        // 3. And there should be no extra selections
        const noExtra = selections.length === correctOptions.length;

        return allCorrectFound && noExtra;
    }

    // Handlers for navigation between shopping list items
    const handlePrevious = () => {
        if (currentActiveIndexInternal > 0) {
            setCurrentActiveIndexInternal(currentActiveIndexInternal - 1);
        }
    };

    const handleNext = () => {
        if (currentActiveIndex < shoppingList.length - 1) {
            setCurrentActiveIndexInternal(currentActiveIndexInternal + 1);
        }
    };

    const ShoppingListComponent = () => {
        // Assuming shoppingList is available in the component's scope.
        // Calculate the total quantity for the summary row.
        const totalQuantity = shoppingList.reduce((acc, item) => acc + item.quantity, 0);

        return (
            <div className="flex w-full flex-col items-center justify-center gap-4">
                <h2 className='mt-[50px]'>To Buy: List {currentActiveIndex + 1}</h2>
                <div className="w-full">
                    {/* Header Row */}
                    <div className="grid grid-cols-4 bg-gray-200 border">
                        <div className="border px-4 py-2 col-span-1 text-center font-bold">
                            S No.
                        </div>
                        <div className="border px-4 py-2 col-span-2 text-start font-bold">
                            Item
                        </div>
                        <div className="border px-4 py-2 col-span-1 text-center font-bold">
                            Qty
                        </div>
                    </div>
                    {/* Data Rows */}
                    {shooppingListBreif.map((item, index) => (
                        <div key={index} className="grid grid-cols-4 text-start">
                            <div className="border px-4 py-2 col-span-1 text-center">{index + 1}</div>
                            <div className="border px-4 py-2 col-span-2">{item.item}</div>
                            <div className="border px-4 py-2 col-span-1 text-center">x{item.quantity}</div>
                        </div>
                    ))}
                    {/* Summary Row */}
                    <div className="grid grid-cols-4">
                        <div className="border px-4 py-2 col-span-1"></div>
                        <div className="border px-4 py-2 col-span-2 font-bold">Total Items</div>
                        <div className="border px-4 py-2 col-span-1 font-bold text-center">{totalQuantity}</div>
                    </div>
                </div>

                {tutorialStep == 0 && isTrialGame && <AppButton
                    onClick={() => {
                        setShowShoppingList(false);
                        setPauseTimer(false);
                    }}
                    variant="rectangularPrimary"
                    className='mt-5 min-w-[100px] text-[16px]'
                >
                    Tutorial
                </AppButton>}

                {!isTrialGame && <AppButton
                    onClick={() => {
                        setShowShoppingList(false);
                        setPauseTimer(false);
                    }}
                    variant="rectangularPrimary"
                    className='mt-5 min-w-[100px] text-[16px]'
                >
                    Start Shopping
                </AppButton>}

                {tutorialStep == -1 && <>
                    <AppButton
                        onClick={() => {
                            setShowShoppingList(false);
                            setPauseTimer(false);
                        }}
                        variant="rectangularPrimary"
                        className='mt-5 min-w-[100px] text-[16px]'
                    >
                        Start Shopping
                    </AppButton>

                    <div
                        onClick={() => {
                            setShowShoppingList(false);
                            setPauseTimer(false);
                            setTutorialStep(0);
                        }}
                        // variant="rectangularPrimary"
                        className='underline text-[14px] cursor-pointer min-w-[100px] flex items-center justify-center'
                    >
                        Tutorial
                    </div>
                </>}

            </div>
        );
    };

    const ShoppingItemOptionsDemo1 = () => {
        // Determine whether any option has a non-empty discount value.
        const showDiscountColumn = currentItem.options.some((option) => {
            const discount = returnDiscountCode(option);
            return discount && discount.trim() !== "";
        });

        // Determine whether any option has a non-empty delivery value.
        const showDeliveryColumn = currentItem.options.some(
            (option) => option?.delivery
        );

        // Total number of columns: Default ordering is:
        // Option, Price, Discount, Delivery, Selected.
        // Remove discount column if not applicable.
        // Remove delivery column if not applicable.
        const totalColumns =
            5 - (!showDiscountColumn ? 1 : 0) - (!showDeliveryColumn ? 1 : 0);

        const gridColsClass = `grid-cols-${totalColumns}`;

        return (
            <div className="flex flex-col gap-2 bg-[#4a4a4a] mt-[5vh] text-white rounded-lg pb-3 text-[14px] w-[95vw]">
                <span className="text-[18px] text-center mb-4">
                    Item {currentActiveIndexInternal + 1} - {currentItem.item} x {currentItem.quantity}
                </span>
                {/* Header Row */}
                <div className={`grid ${gridColsClass} gap-2`}>
                    <div className="flex flex-col items-center justify-center">
                        <span>App</span>
                        <br />
                    </div>
                    <div className="flex flex-col items-center">
                        <span>Price</span>
                        <span className='text-[10px]'>(per item)</span>
                    </div>
                    {/* {showDiscountColumn && <div className='flex flex-col items-center'>Discount</div>} */}
                    {showDiscountColumn&&<div className="flex flex-col items-center">
                        <span>Discount</span>
                        <span className='text-[10px]'>(per item)</span>
                    </div>}
                    {showDeliveryColumn && <div className='flex flex-col items-center'>Delivery</div>}
                    <div>Selected</div>
                </div>
                {/* Option Rows */}
                <div className="flex flex-col gap-2">
                    {currentItem.options.map((option, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center justify-center w-full h-full"
                        >
                            {option.addedFreeItems && (
                                <div className="w-full flex items-start justify-end text-[#ccf900]">
                                    Free items added
                                </div>
                            )}
                            <div
                                className={`bg-[#3a3a3a] rounded-lg py-2 w-full items-center grid ${gridColsClass} gap-2`}
                            >
                                <div className="p-1 items-left justify-left">{option.option}</div>
                                <div className='flex flex-col items-center justify-center'>₹{option.price}</div>
                                {showDiscountColumn && <div className='flex flex-col items-center justify-center'>{returnDiscountCode(option) === "" ? "-" : returnDiscountCode(option)}</div>}
                                {showDeliveryColumn && <div className='flex flex-col items-center justify-center'>{option.delivery ? `₹${option.delivery}` : "FREE"}</div>}
                                <div className="flex items-center gap-1 justify-start">
                                    <button
                                        onClick={() => updateSelected(index, -1)}
                                        className="h-[17px] w-[17px] flex items-center justify-center rounded-lg"
                                    >
                                        -
                                    </button>
                                    <span>{option.selected}</span>
                                    <button
                                        onClick={() => updateSelected(index, 1)}
                                        className="h-[17px] w-[17px] flex items-center justify-center rounded-lg"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Navigation Buttons container wrapped in a relative container */}
                {(!isTrialGame || (isTrialGame && tutorialStep !== 0)) && (
                    <div className="relative z-20 flex items-center justify-between gap-2 mt-8">
                        <div className="absolute -top-32 left-1/2 transform -translate-x-1/2 bg-white p-2 border border-gray-200 rounded shadow z-30 w-[80vw]">

                            <div
                                className="
                                absolute
                                -top-4   
                                -left-4  
                                w-10 h-10 
                                rounded-full
                                bg-black
                                border-2 border-[#ccf900]
                                flex items-center justify-center
                                text-white font-bold"
                            >
                                {tutorialStep + 1}
                            </div>

                            <p className="text-left text-gray-800 text-[16px]">
                                Click Next and Prev to add all items from the list given
                            </p>

                            <p className="font-bold text-gray-800 text-left text-[16px]">Click Prev/Next to continue</p>

                        </div>

                        <AppButton
                            onClick={() => setTutorialStep(tutorialStep + 1)}
                            variant="rectangularPrimary"
                        >
                            Prev Item
                        </AppButton>
                        <AppButton
                            onClick={() => setTutorialStep(tutorialStep + 1)}
                            variant="rectangularPrimary"
                            className="animate-pulse"
                        >
                            Next Item
                        </AppButton>


                    </div>
                )}
            </div>
        );
    };


    const submitAnswers = () => {
        // Show the wait screen and pause the timer
        setShowCart(false);
        setShowWaitScreen(true);
        setPauseTimer(true);

        setShowInGameNotificationPopup(true);

        const shopppingCart = shoppingList.map(item => {
            const selectedOptions = item.options.filter(option => option.selected > 0);
            const { cheapestTotal, item: itemName, quantity, correctOptions } = item;

            //calculate final cost
            const finalCost = selectedOptions.reduce((acc, option) => {
                const selected = option.selected;
                const price = option.price;
                const discount = option.discount;
                const discountMode = option.discountMode;
                const delivery = option.delivery ?? 0;
                let optionFinalCost = 0; // renamed for clarity

                if (discountMode === "percentage") {
                    // Apply percentage discount for each unit and then multiply by selected quantity
                    const discountedPrice = price - (price * discount / 100);
                    optionFinalCost = discountedPrice * selected;
                } else if (discountMode === "mrpDiscount") {
                    // Apply a fixed discount amount per item
                    const discountedPrice = price - discount;
                    optionFinalCost = discountedPrice * selected;
                } else if (discountMode === "x+y") {
                    // "x+y" discount assumed to mean "buy X get Y free"
                    const groupSize = discount.buy + discount.free;
                    const groups = Math.floor(selected / groupSize);
                    const remainder = selected % groupSize;
                    const paidForRemainder = Math.min(remainder, discount.buy);
                    optionFinalCost = price * (groups * discount.buy + paidForRemainder);
                } else {
                    optionFinalCost = price * selected;
                }
                optionFinalCost += delivery; // Add delivery cost to the final cost
                return acc + optionFinalCost;
            }, 0);

            const numberOfItems = selectedOptions.reduce((acc, option) => {
                return acc + option.selected;
            }, 0);

            let score = 1;

            if (cheapestTotal === finalCost) {
                score = 3;
            }

            return {
                item: itemName,
                quantity: quantity,
                itemsBought: numberOfItems,
                selectedOptions: selectedOptions,
                finalCost: finalCost,
                cheapestTotal: cheapestTotal,
                score: score,
                currentActiveIndex,
                currentIndexListTimeTaken: roundTimerDuration - timerRef.current,
                givenOptions: item.options,
                correctOptions: correctOptions,
            }
        });

        scoreRef.current = scoreRef.current + shopppingCart.reduce((acc, item) => {
            return acc + item.score;
        }, 0);

        const responsePurchases = gameState.responsePurchases || [];
        let attempts = gameState.attempts || 0;
        let correctAttempts = gameState.correctAttempts || 0;
        attempts += shopppingCart.length;
        //need a change if scoring is changed;
        correctAttempts += shopppingCart.reduce((acc, item) => {
            // return acc + item.score;
            if (item.score === 3) {
                return acc + 1;
            }
            else {
                return acc;
            }

        }, 0);

        //make the shoppingCart flat.shopping cart is an array of objects.

        responsePurchases.push(...shopppingCart);


        const updatedGameState = {
            ...gameState,
            score: scoreRef.current,
            attempts: attempts,
            correctAttempts: correctAttempts,
            responsePurchases: responsePurchases,
        }

        if (!isTrialGame) {
            updateGameState(updatedGameState);
        }


        setSubmittedShoppingList(shopppingCart);
        // After a delay, submit the game.
        setTimeout(() => {
            submitGame(isTrialGame);
        }, 10000);
    };

    const renderRoundPlayedPopup = () => {

        //get all the selected options and their selected values

        const selectedOptions = shoppingList.reduce((acc, item) => {
            const selectedOptions = item.options.filter(option => option.selected > 0);
            const selectedOptionsWithQuantity = selectedOptions.map(option => ({
                ...option,
                quantity: item.quantity,
                item: item.item
            }));
            return acc.concat(selectedOptionsWithQuantity);
        }
            , []);

        //check all items are selected with quantity that matches quantity in shooppingListBreif

        const allItemsSelected = shooppingListBreif.every(item => {
            //there can be multiple options for the same item, so we need to add the quantity of all options for the same item
            const totalSelected = selectedOptions.reduce((acc, option) => {
                if (option.item === item.item) {
                    return acc + option.selected;
                }
                return acc;
            }
                , 0);

            return totalSelected === item.quantity;
        });

        return (
            <Dialog
                open={showCart}
                onClose={() => {
                    setShowCart(false);
                }}
                className="register-success"
            >
                <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-6 leading-6 text-base">
                    <span className="text-[20px] text-center font-bold mb-4">
                        YOUR CART
                    </span>
                    <div className=" grid grid-cols-3 items-center text-center font-bold p-0 text-[16px]">
                        <p>Item</p>
                        <p>App</p>
                        <p>Qty</p>
                    </div>
                    {selectedOptions.map((option, index) => (
                        <div key={index} className="grid grid-cols-3 items-center text-center font-bold p-0  m-0 text-[14px]">
                            <div>{option.item}</div>
                            <div>{option.option}</div>
                            <div>{option.selected}</div>
                        </div>
                    ))}


                    {allItemsSelected ? (
                        <div className='flex items-center justify-center w-full h-full'>
                            <AppButton
                                className="rounded-[115px] min-w-[100px] min-h-[35px] self-center items-center  mt-4"
                                onClick={submitAnswers}

                            >
                                Place Order
                            </AppButton>
                        </div>)



                        : (
                            <div className='flex flex-col items-center justify-center w-full h-full gap-4 mt-4'>
                                <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                                    <span className='text-[#FF7B7B]'>
                                        Items are missing or extra in your cart
                                    </span>
                                    <span> Match the shopping list to proceed</span>
                                </div>
                                <AppButton
                                    className="rounded-[115px] min-w-[100px] min-h-[35px] self-center items-center"
                                    onClick={() => {
                                        setShowCart(false);
                                    }}
                                >
                                    Continue Shopping

                                </AppButton>
                            </div>
                        )}

                </div>
            </Dialog>
        );
    }

    const ShoppingItemOptions = () => {
        // Determine whether any option has a non-empty discount value.
        const showDiscountColumn = currentItem.options.some((option) => {
            const discount = returnDiscountCode(option);
            return discount && discount.trim() !== "";
        });

        // Determine whether any option has a non-empty delivery value.
        const showDeliveryColumn = currentItem.options.some(

            (option) => option?.delivery
        );

        // Total number of columns: Default ordering is:
        // Option, Price, Discount, Delivery, Selected.
        // Remove discount column if not applicable.
        // Remove delivery column if not applicable.
        const totalColumns =
            5 - (!showDiscountColumn ? 1 : 0) - (!showDeliveryColumn ? 1 : 0);

        const gridColsClass = `grid-cols-${totalColumns}`;
        console.log("gridColsClass", gridColsClass);


        return (
            <div className="flex flex-col gap-2 bg-[#4a4a4a] mt-[5vh] text-white  pb-3 rounded-lg text-[14px] w-[95vw]">
                <span className="text-[18px] text-center text-primary-yellow mb-4">
                    Item {currentActiveIndexInternal + 1} - {currentItem.item} x {currentItem.quantity}
                </span>
                {/* Header Row */}
                <div className={`grid ${gridColsClass} gap-2`}>
                    <div className="flex flex-col items-center justify-center">
                        <span>App</span>
                        <br />
                    </div>
                    <div className="flex flex-col items-center">
                        <span>Price</span>
                        <span className='text-[10px]'>(per item)</span>
                    </div>
                    {/* {showDiscountColumn && <div className='flex flex-col items-center'>Discount</div>} */}
                    {showDiscountColumn&& <div className="flex flex-col items-center">
                        <span>Discount</span>
                        <span className='text-[10px]'>(per item)</span>
                    </div>}
                    {showDeliveryColumn && <div className='flex flex-col items-center'>Delivery</div>}
                    <div className='flex flex-col items-center'>Qty</div>
                </div>
                {/* Option Rows */}
                <div className="flex flex-col gap-2">
                    {currentItem.options.map((option, index) => (
                        <div className='flex flex-col items-center justify-center w-full h-full'>
                            {option.addedFreeItems && <div className='w-full flex items-start justify-end text-[#ccf900]'> Free items added</div>}
                            <div
                                key={index}
                                className={`bg-[#3a3a3a] rounded-lg py-2 w-full items-center grid ${gridColsClass} gap-2`}
                            >

                                <div className="p-1 items-left justify-left">{option.option}</div>
                                <div className='flex flex-col items-center justify-center'>₹{option.price}</div>
                                {/* {showDiscountColumn && <div className='flex flex-col items-center justify-center text-center text-[12px]'>{returnDiscountCode(option) === "" ? "-" : returnDiscountCode(option)}</div>} */}
                                {showDiscountColumn && (
                                    <div
                                        className={`flex flex-col items-center justify-center text-center ${returnDiscountCode(option).includes("FREE") ? "text-[12px]" : "text-[14px]"
                                            }`}
                                    >
                                        {returnDiscountCode(option) === "" ? "-" : returnDiscountCode(option)}
                                    </div>
                                )}
                                {showDeliveryColumn && <div className='flex flex-col items-center justify-center'>{option.delivery ? `₹${option.delivery}` : "FREE"}</div>}
                                <div className="flex items-center gap-1 justify-center">
                                    <button
                                        onClick={() => updateSelected(index, -1)}
                                        className="h-[17px] w-[17px] flex items-center justify-center rounded-lg"
                                    >
                                        -
                                    </button>
                                    <span>{option.selected}</span>

                                    {tutorialStep == 0 && isTrialGame && option?.option?.toLowerCase() ===
                                        currentItem?.correctOptions?.[0].option?.toLowerCase() ? (<motion.button
                                            onClick={() => updateSelected(index, 1)}
                                            className="h-[17px] w-[17px] flex items-center justify-center rounded-lg"
                                            animate={{ scale: [1, 1.2, 1] }}
                                            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                                        >
                                            +
                                        </motion.button>) : (
                                        <button
                                            onClick={() => updateSelected(index, 1)}
                                            className="h-[17px] w-[17px] flex items-center justify-center rounded-lg"
                                        >
                                            +
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Navigation Buttons */}
                {(!isTrialGame || isTrialGame && tutorialStep !== 0) && <div className="flex items-center justify-between gap-2 mt-8">
                    <AppButton
                        onClick={handlePrevious}
                        disabled={currentActiveIndexInternal === 0}
                        variant="rectangularPrimary"
                    >
                        Prev Item
                    </AppButton>
                    {currentActiveIndexInternal !== shoppingList.length - 1&& <AppButton
                        onClick={handleNext}
                        disabled={currentActiveIndexInternal === shoppingList.length - 1}
                        variant="rectangularPrimary"
                    >
                        Next Item
                    </AppButton>}
                    {currentActiveIndexInternal === shoppingList.length - 1&& <AppButton
                        onClick={handleShowCart}
                        // disabled={currentActiveIndexInternal === shoppingList.length - 1}
                        variant="rectangularPrimary"
                    >
                        View Cart
                    </AppButton>}

                </div>}
            </div>
        );
    };

    const getItemsSelectedText = () => {
        const totalItemsSelected = shoppingList.reduce((acc, item) => {
            const selectedOptions = item.options.filter(option => option.selected > 0);
            const totalSelected = selectedOptions.reduce((sum, option) => sum + option.selected, 0);
            return acc + totalSelected;
        }, 0);

        if (totalItemsSelected === 1) {
            return `${totalItemsSelected} Item`;
        }
        return `${totalItemsSelected} Items`;
    }

    const handleShowCart = () => {
        //
        setShowCart(true);
    }

    const finishTutorial = () => {
        setTutorialStep(-1);
        const updatedShoppingList = currentActiveQuestion.shoppingList.map(item => ({
            item: item.item,
            quantity: item.quantity,
        }));
        setShoppingListBreif(updatedShoppingList);
        const tempList = currentActiveQuestion.shoppingList.map(item => ({
            //map through the shopping list and set the options to 0
            ...item,
            options: item.options.map(option => ({
                ...option,
                selected: 0,
            })),
        }));
        setShoppingList(tempList);
        setCurrentActiveIndexInternal(0)
        setShowShoppingList(true)
        setShowWaitScreen(false);
        setPauseTimer(true);
    }


    function CheapestPrompt({ correctOptions }) {
        if (!correctOptions?.length) return null;

        const lines = correctOptions.map(({ option, quantity }) => {
            const provider = option.charAt(0).toUpperCase() + option.slice(1);
            const unit = `item ${quantity > 1 ? 's' : ''}`;
            return `For now, add ${quantity} ${unit} from ${provider}`;
        });

        return (
            <div className='relative'>
                <div
                    className="
      absolute
      -top-10   
      -left-8   
      w-10 h-10 
      rounded-full
      bg-black
      border-2 border-[#ccf900]
      flex items-center justify-center
      text-white font-bold
    "
                >
                    {tutorialStep + 1}
                </div>
                <p className="text-left text-gray-800">
                    Find the cheapest app to buy this item and add the quantity
                    <br />
                    <br />
                    <span className="font-bold">{lines.join(' and ')} to continue</span>
                </p>


            </div>
        );
    }


    return (
        <div className="h-screen flex flex-col items-center justify-start">
            {showShoppingList ? (
                // Render the shopping list if showShoppingList is true.
                <>
                    <div className="w-full flex justify-between mt-2">
                        <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                            <span className="text-[20px] text-center"> List </span>
                            <span className="text-[20px] text-center">{currentActiveIndex + 1} / {totalQuestions}</span>
                        </div>


                        <Timer
                            duration={roundTimerDuration}
                            stroke={5}
                            timerEnd={submitAnswers}
                            startTimer={!pauseTimer}
                            key={currentActiveIndex}
                            localTimer={true}
                            color="black"
                            timeRef={timerRef}
                        />

                        <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                            <span className="text-[20px] text-center"> Score </span>
                            <span className="text-[20px] text-center">{scoreRef.current}</span>
                        </div>


                    </div>
                    <ShoppingListComponent />
                </>
            ) : (
                <>
                    {showWaitScreen &&
                        <div className="w-[95vw] bg-white flex flex-col items-start justify-center gap-8">
                            <div className="w-full flex justify-between">
                                <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                                    <span className="text-[20px] text-center"> List </span>
                                    <span className="text-[20px] text-center">{currentActiveIndex + 1} / {totalQuestions}</span>
                                </div>

                                <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                                    <span className="text-[20px] text-center"> Score </span>
                                    <span className="text-[20px] text-center">{scoreRef.current}</span>
                                </div>


                            </div>

                            <div className="w-full h-full bg-[#4A4A4A] flex  flex-col items-start justify-center min-h-[50vh] mt-[10vh] text-white rounded-lg">

                                <div className='w-full text-center flex items-center justify-center py-2'>LIST {currentActiveIndex + 1} SUMMARY</div>

                                <div className='flex flex-col w-full items-center justify-center w-full h-full bg-[#3A3A3A] rounded-xl'>

                                    <div className="flex flex-col gap-2 w-full">
                                        {/* Header Row */}
                                        <div className="grid grid-cols-4 items-center font-bold border-b pb-2">
                                            <div className='text-center'>Item</div>
                                            <div className='text-center'>Your Pick</div>
                                            <div className='text-center'>Cheapest</div>
                                            <div className='text-center'>Score</div>
                                        </div>
                                        {/* Shopping List Items */}
                                        {submittedShoppingList.map((item, index) => (
                                            <div key={index} className="grid grid-cols-4 items-center">
                                                <div className='text-center'>{item.item} x{item.quantity}</div>
                                                <div className='text-center'>₹{item.finalCost}</div>
                                                <div className='text-center'>₹{item.cheapestTotal}</div>
                                                <div className='text-center'>{item.score}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className='w-full bg-[#3a3a3a] flex items-center justify-center'>
                                    {showInGameNotificationPopup && <InGameNotificationPopup showProceedAndTimeLeft={true} showTimer={currentActiveIndex != totalQuestions.length - 1} PopupDuration={10} />}
                                </div>

                            </div>



                        </div>
                    }
                    {!showWaitScreen && (!isTrialGame || tutorialStep == -1) && (
                        <>
                            <div className="w-full flex justify-between mt-2">
                                <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                                    <span className="text-[20px] text-center"> List </span>
                                    <span className="text-[20px] text-center">{currentActiveIndex + 1} / {totalQuestions}</span>
                                </div>
                                <Timer
                                    duration={roundTimerDuration}
                                    stroke={5}
                                    timerEnd={submitGame}
                                    startTimer={!pauseTimer}
                                    key={currentActiveIndex}
                                    localTimer={true}
                                    color="black"
                                    timeRef={timerRef}
                                />

                                <div className=' flex flex-col items-center justify-center w-full h-full text-[14px]'>
                                    <span className="text-[20px] text-center"> Score </span>
                                    <span className="text-[20px] text-center">{scoreRef.current}</span>
                                </div>
                            </div>


                            {ShoppingItemOptions()}

                            <BottomButtonBar
                                text={getItemsSelectedText()}
                                buttonProps={{
                                    onClick: handleShowCart,
                                    text: "View Cart",
                                }}
                            />
                        </>

                    )}
                    {!showWaitScreen && isTrialGame && tutorialStep == 0 && (
                        <>
                            <div className="relative ">

                                <BottomButtonBar
                                    text={getItemsSelectedText()}
                                    buttonProps={{
                                        onClick: handleShowCart,
                                        text: "View Cart",
                                    }}
                                />
                                <div className="fixed inset-0 bg-[#D9D9D9] opacity-70 z-10"></div>

                                {/*
                            The container for the exempt components (ShoppingItemOptions and the popup)
                            with a higher z-index so they appear above the overlay.
                          */}
                                <div className="relative z-20 w-full text-[28px] text-center mt-[20px]">
                                    HOW TO PLAY
                                </div>
                                <div className="relative z-20">
                                    {ShoppingItemOptions()}

                                    {/*
                              White popup rendered below ShoppingItemOptions.
                              - mt-4 adds a margin top.
                              - p-4 adds padding.
                              - bg-white creates a white background.
                              - border border-gray-200 gives it a light border.
                              - rounded applies rounded corners.
                              - shadow-lg creates a subtle shadow effect.
                            */}
                                    <div className='flex flex-col items-center justify-center w-full h-full'>
                                        <div className="mt-4 p-4 bg-white border border-gray-200 rounded shadow-lg w-[80vw] left-1/2">

                                            <CheapestPrompt correctOptions={currentItem.correctOptions} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>

                    )}
                    {!showWaitScreen && isTrialGame && tutorialStep == 1 && (
                        <>
                            {/* Parent container: relative so that we can manage stacking context */}
                            <div className="relative">

                                <div className="relative z-20 w-full text-[28px] text-center mt-[20px]">
                                    HOW TO PLAY
                                </div>

                                {ShoppingItemOptionsDemo1()}

                                <BottomButtonBar
                                    text={getItemsSelectedText()}
                                    buttonProps={{
                                        onClick: handleShowCart,
                                        text: "View Cart",
                                    }}
                                />

                                <div className="fixed inset-0 bg-[#D9D9D9] opacity-70 z-10"></div>
                            </div>
                        </>


                    )}

                    {!showWaitScreen && isTrialGame && tutorialStep == 2 && (
                        <>
                            {/* Wrap everything in a relative container to manage z-index stacking */}
                            <div className="relative">


                                {ShoppingItemOptions()}

                                {/*
                            Render the full-screen white semi-translucent overlay.
                            - `fixed inset-0` ensures full viewport coverage.
                            - `bg-white opacity-70` gives the white masking effect.
                            - `z-10` sets it above the base content.
                          */}
                                <div className="fixed inset-0 bg-[#D9D9D9] opacity-70 z-10"></div>

                                {/*
                            Render BottomButtonBar and the popup inside a container with a higher z-index.
                            This container is "lifted" above the overlay.
                          */}
                                <div className="relative z-20">

                                    <div className="absolute -top-20 w-[80vw] left-1/2 transform -translate-x-1/2 bg-white p-2 border border-gray-200 rounded shadow z-30">
                                        {/* half‑in, half‑out circle */}
                                        <div
                                            className="
                                                absolute
                                                -top-5   
                                                -left-5   
                                                w-10 h-10 
                                                rounded-full
                                                bg-black
                                                border-2 border-[#ccf900]
                                                flex items-center justify-center
                                                text-white font-bold
                                                "
                                        >
                                            {tutorialStep + 1}
                                        </div>

                                        <p className="text-left text-gray-800">
                                            View cart to check quantities before placing final order
                                        </p>
                                        <p className="text-left text-gray-800 font-bold">
                                            Click View Cart to end tutorial
                                        </p>
                                    </div>


                                    {/* BottomButtonBar remains visible above the overlay */}
                                    <BottomButtonBar
                                        text={getItemsSelectedText()}
                                        buttonProps={{
                                            onClick: finishTutorial,
                                            text: "View Cart",
                                            className: "animate-pulse text-[18px]",
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {renderRoundPlayedPopup()}
                </>
            )}
        </div>
    );

}


export default ShoppingCartRound;